module.exports = __webpack_public_path__ + "static/media/trudvsem-logo.f56271cc.svg";